/**
 * Vibration API helper. Funciona en Android Chrome, no en iOS Safari.
 * Feature-detect + no-op silencioso si no hay soporte.
 *
 * Patrones:
 *   tap()      — feedback corto para acciones del usuario (toggle, swipe)
 *   alert()    — patrón doble para notificación importante (push, conflicto)
 *   critical() — patrón largo + repetido para AOG, BLOCKED, safety
 */
const supported = () => typeof navigator !== "undefined" && typeof navigator.vibrate === "function";

const safeVibrate = (pattern) => {
  if (!supported()) return false;
  try {
    return navigator.vibrate(pattern);
  } catch {
    return false;
  }
};

export const tap = () => safeVibrate(10);
export const alert = () => safeVibrate([60, 40, 60]);
export const critical = () => safeVibrate([100, 50, 100, 50, 200]);

export const vibrate = safeVibrate;
export const isVibrationSupported = supported;
